/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface NotificationsPreferences {
  /** Indicates if email notifications are enabled */
  emailEnabled: boolean;
  /** Indicates if SMS notifications are enabled */
  smsEnabled: boolean;
}
